import React from 'react';
import PropTypes from 'prop-types';
import {DownIcon, UpIcon} from './Icons';
import {Dropdown} from '@learningblocks/storybook-components';
import {FeedbackIcon} from '../FeedbackIcon';

export function DropdownCell(props) {
  const onChange = ({value}) => {
    props.onChange({id: props.id, value});
  };

  const setClassName = () => {
    let className = props.className;
    if (props.showFeedback && props.feedback) {
      className += ` ${props.isCorrect ? 'correct' : 'incorrect'}`;
    }
    return className;
  };

  return (
    <div className={setClassName()}>
      <Dropdown
        placeholder={props.placeholder}
        className={`${props.className}_dropdown`}
        options={props.options}
        value={props.value}
        onChange={onChange}
        disabled={props.disabled}
        iconOpen={DownIcon}
        iconClose={UpIcon}
      />
      <FeedbackIcon
        isSuccess={props.isCorrect}
        showFeedback={props.showFeedback && props.feedback}
        className={`${props.className}_feedback`}
        feedback={props.feedback}
      />
    </div>
  );
}

DropdownCell.propTypes = {
  /**
   * Unique Id for the cell
   */
  id: PropTypes.string,
  /**
   * placeholder for the cell
   */
  placeholder: PropTypes.string,
  /*
   * className to be set on component
   */
  className: PropTypes.string,
  /**
   * Options associated with drodown
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value of the option
       */
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      /**
       * Label for option
       */
      label: PropTypes.string,
    })
  ),
  /*
   * Currently selected option value
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Funciton to invoke when an option is selected
   */
  onChange: PropTypes.func,
  /**
   * Boolean to check if the dropdown is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Boolean feedback on value being correct/incorrect
   */
  isCorrect: PropTypes.bool,
};